var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4413 24.0175H9.10718",
    stroke: "url(#paint0_linear_77_5289)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4413 16.8654H9.10718",
    stroke: "url(#paint1_linear_77_5289)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8136 9.73014H9.10718",
    stroke: "url(#paint2_linear_77_5289)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7699 1C21.7699 1 8.65504 1.00683 8.63454 1.00683C3.91954 1.03588 1 4.13821 1 8.87029V24.5801C1 29.3361 3.94175 32.4504 8.69775 32.4504C8.69775 32.4504 21.8109 32.4453 21.8331 32.4453C26.5481 32.4162 29.4694 29.3122 29.4694 24.5801V8.87029C29.4694 4.11429 26.5259 1 21.7699 1Z",
    stroke: "url(#paint3_linear_77_5289)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_5289",
    x1: 24.1428,
    y1: 21.8647,
    x2: 24.3377,
    y2: 23.9559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_77_5289",
    x1: 24.1428,
    y1: 14.7126,
    x2: 24.3377,
    y2: 16.8038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_77_5289",
    x1: 14.8445,
    y1: 7.57733,
    x2: 15.3306,
    y2: 9.56805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_77_5289",
    x1: 35.7049,
    y1: -22.9081,
    x2: 54.2967,
    y2: 2.10961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26468B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a2eb36fc96f9c447559c92644da04d29.svg";
export { ForwardRef as ReactComponent };